var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1467_10156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 29.167L69.125 23.292L42.7083 49.7087L48.5833 55.5837L75 29.167ZM92.6666 23.292L48.5833 67.3753L31.1666 50.0003L25.2916 55.8753L48.5833 79.167L98.5833 29.167L92.6666 23.292ZM1.70831 55.8753L25 79.167L30.875 73.292L7.62498 50.0003L1.70831 55.8753Z",
    fill: "url(#paint0_linear_1467_10156)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1467_10156",
    x1: 50.1458,
    y1: 23.292,
    x2: 50.1458,
    y2: 79.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9b99c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d4ed8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1467_10156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneAll);
export default __webpack_public_path__ + "static/media/done_all.37dee06c1ee2dcc8b3989694911ec1cb.svg";
export { ForwardRef as ReactComponent };